import { api } from '@/services/backend/http-client';
import { CountryResponse, GisFilterZoneResponseType } from './types';

export const getCountries = async (): Promise<CountryResponse[]> => {
  const response = await api.get<CountryResponse[]>('/reference/data', {
    params: {
      type: 'CNT',
    },
    isPublicEndpoint: true,
  });

  if (response.data.length === 0) {
    return [];
  }

  return response.data.sort((a, b) => a.nameEn.localeCompare(b.nameEn));
};

export const getGisFilterZones = async (): Promise<GisFilterZoneResponseType[]> => {
  const response = await api.get<GisFilterZoneResponseType[]>(`/gis-filter/zone`);
  return response.data;
};
